export default Object.freeze({
    CREATED: 'CREATED',
    READY: 'READY',
    BROADCASTING: 'BROADCASTING',
    WAITING: 'WAITING',
    EXPANDING: 'EXPANDING',
    RESERVED: 'RESERVED',
    COMPLETED: 'COMPLETED',
    STOPPED: 'STOPPED',
    CANCELLED: 'CANCELLED',
    EXHAUSTED: 'EXHAUSTED',
})
